<template>
  <Drawer width="600" title="编辑" v-model="drawerOpened">
    <div class="drawer-content">
      <div class="content-left">
        <div class="item">
          <h3>客户名</h3>
          <div>
            {{ openedTechService ? openedTechService.customer.name : "" }}
          </div>
        </div>
        <div class="item">
          <h3>状态</h3>
          <div>
            {{ openedTechService ? openedTechService.status : "" }}
          </div>
        </div>
        <div class="item">
          <h3>创建人</h3>
          <div>
            {{ openedTechService ? openedTechService.createdBy.name : "" }}
          </div>
        </div>
        <div class="item">
          <h3>指派的技术员</h3>
          <div>
            {{ openedTechService ? openedTechService.createdBy.name : "" }}
          </div>
        </div>
        <div class="item">
          <h3>实验内容</h3>
          <div>
            {{ openedTechService ? openedTechService.content : "" }}
          </div>
        </div>
      </div>
      <div class="content-right">
        <h2>销售项目</h2>
        <div v-for="item in salesList" :key="item._id">
          <h4>{{ item.abbr }}</h4>
          <div v-for="recipe in item.recipe" :key="recipe._id">
            <div>#{{ recipe.NoId }} {{ recipe.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </Drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "EditTechService",
  data() {
    return {
      drawerOpened: false,
      openedTechService: null,
      salesList: [],
    };
  },
  computed: {
    ...mapState({}),
  },
  methods: {
    ...mapActions({
      getSales: "sales/getSalesAction",
    }),
    async openDrawer(techService) {
      this.openedTechService = techService;
      if (this.openedTechService) {
        const data = await this.getSales({
          customer: this.openedTechService.customer._id,
        });

        this.salesList = data.salesList;
        if (this.openedTechService.recipeSales.length > 0) {
          for (let i = 0; i < this.openedTechService.recipeSales.length; i++) {
            for (let j = 0; j < this.salesList.length; j++) {
              this.salesList[j].recipe = [];
              if (
                this.salesList[j]._id ===
                this.openedTechService.recipeSales[i].sales
              ) {
                this.salesList[j].recipe.push(
                  this.openedTechService.recipeSales[i]
                );
              }
            }
          }
        } else {
        }
      }
      this.drawerOpened = true;
    },
  },
};
</script>
<style lang="stylus" scoped>
.drawer-content
  display flex

.content-left
  margin-right 30px

.item
  font-size 15px
  flex 1
  margin-bottom 15px
</style>